import { CircularProgress } from '@mui/material';
import { ComponentType } from 'react';
import { Navigate } from 'react-router';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { FlagName } from '../../utils/flags.gen';

interface FeatureFlagGuardProps {
  component: ComponentType;
  requiredFlag: FlagName;
}

/**
 * Route guard that renders `component` only when `requiredFlag` is enabled for
 * the current user, otherwise redirects home. Based on {@link RoleGuard}.
 */
export function FeatureFlagGuard({ component: Component, requiredFlag }: FeatureFlagGuardProps) {
  const { isEnabled, isLoading } = useFeatureFlags();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  if (!isEnabled(requiredFlag)) {
    return <Navigate to='/' replace />;
  }

  return <Component />;
}

export default FeatureFlagGuard;
